import { SignIn } from 'components/Auth/SignIn/SignIn'

export function SignInPage(): JSX.Element {
  return <SignIn />
}
